import { useAppState } from '../../store/appstate';
import { ConnectedStore } from '../../types/ConnectedStore';

const buildTag = (firstPart: string, secondPart: string, thirdPart: string) => {
    return `${firstPart}-${secondPart}-${thirdPart}`;
};

const getParts = (value: string) => {
    const partList: string[] = ['all', value];
    return partList;
};

const generateTags = (firstSection: string, secondSection: string, thirdSection: string) => {
    const tagsList: string[] = [];
    const firstSectionParts = getParts(firstSection);
    const secondSectionParts = getParts(secondSection);
    const thirdSectionParts = getParts(thirdSection);

    firstSectionParts.forEach(fs => {
        secondSectionParts.forEach(ss => {
            thirdSectionParts.forEach(ts => {
                tagsList.push(buildTag(fs, ss, ts));
            });
        });
    });
    return tagsList;
};

const noConnectedStores: ConnectedStore[] = [];

export const useManagementTags = () => {
    const organization = useAppState<string>(s => s.session.user?.organization?.id || '');
    const availableStores = useAppState<ConnectedStore[]>(
        s => s.session.selectedOrganization?.connectedStores ?? noConnectedStores
    );

    const userManagementUserTags = generateTags('usermanagement', organization, 'userlist');
    const userManagementGroupTags = generateTags('usermanagement', organization, 'grouplist');
    const apiSecretTags = generateTags('usermanagement', organization, 'apisecret');
    // Organization write: the backend requires it for changing the organization itself, such as adding merchants.
    const organizationTags = generateTags('usermanagement', organization, 'organization');
    // Store write for the whole organization. Store-scoped tags (all-{storeId}-store) do not count.
    const organizationStoreTags = [`${organization}-all-store`, `all-all-store`];
    const developerLogsTags = [`${organization}-all-developerlogs`, `all-all-developerlogs`];
    const webhooksTags = (availableStores?.map(x => `all-${x.id}-webhookendpoints`) || []).concat([
        'all-all-webhookendpoints',
    ]);
    const b2bTags = [`${organization}-all-buyermanagement`, `all-all-buyermanagement`];
    const mfaTags = [`${organization}-all-mfa`, `all-all-mfa`];

    return {
        userManagementUserTags,
        userManagementGroupTags,
        apiSecretTags,
        organizationTags,
        organizationStoreTags,
        webhooksTags,
        developerLogsTags,
        b2bTags,
        mfaTags,
    };
};

export default { useManagementTags };
